import { defineStore } from "pinia";
import type { LatLon, PlaceHit, PoiHit, RouteHit } from "../search/types";

// Мост между панелями поиска и картой: панели кладут выбранный результат,
// MapView рисует его (useSearchLayers) и сообщает центр карты / GPS-позицию.
export type SearchFocus =
  | { kind: "place" | "poi"; hit: PlaceHit | PoiHit }
  | { kind: "route"; hit: RouteHit };

export const useSearchFocusStore = defineStore("searchFocus", {
  state: () => ({
    focus: null as SearchFocus | null,
    // Кто выставил focus: панелей две (десктоп и мобильная), и каждая должна
    // сбрасывать только свой выбор, а не чужой.
    focusOwner: null as string | null,
    mapCenter: null as LatLon | null,
    userPosition: null as LatLon | null,
  }),
  actions: {
    setFocus(f: SearchFocus, owner: string | null = null) {
      this.focus = f;
      this.focusOwner = owner;
    },
    // Без owner - безусловно; с owner - только если выбор сделал он же.
    clearFocus(owner?: string) {
      if (owner !== undefined && this.focusOwner !== owner) return;
      this.focus = null;
      this.focusOwner = null;
    },
    setMapCenter(p: LatLon) {
      this.mapCenter = p;
    },
    setUserPosition(p: LatLon | null) {
      this.userPosition = p;
    },
  },
});
